define('views/parts/panel/base-panel',[
    // Libs
    'underscore', 'backbone', 'utils',
    // events
    'services/events/conversation-events',
    // Views
    'src/views/responsive-view',
    'views/parts/panel/panel'
], function(
    // Libs
    _, Backbone, U,
    // events
    ConversationEvents,
    // views
    VResponsive,
    VPanel
) {

    var _extend = _.extend,
        _result = _.result;

    var VBasePanel = VResponsive.extend({
        header: {
            title: "Panel",
            subtitle: "Details",
        },
        buttons: {
            close: 'close',
            // expand: 'onExpandPanel'
        },

        defaultView: null,

        // regions: {
        //     scrollable: ".scrollable",
        // },

        constructor: function(opt) {

            var options = this.options;
            if (!options) options = this.options = _extend({}, _result(this, 'defaults'), opt);

            this.tabs = new Backbone.Collection(_result(this, 'tabs', null));

            this.view = {
                layout: new VPanel({
                    header: _extend({}, _result(this, 'buttons'), _result(this, 'header')),
                    tabs: this.tabs.models,
                    context: this
                }),
            };

            this.listenTo(ConversationEvents, 'redirectedToConversation', this.onRedirectedToConversation);

            VBasePanel.__super__.constructor.apply(this, arguments);
        },

        render: function() {
            // .setMenuActionsWidth();

            // var $scrollable = this.zone.$scrollable.off('scroll'),
            //     menu = this.getMenu();
            // if (menu) $scrollable.scroll(this.onScroll.bind(this));
            this.assign(this.view.layout, this.el);
            if (this.defaultView) this.showContent(this.defaultView);

            return this;
        },

        is: function(view) {
            return this.view.layout.is(view);
        },

        getContentViewOptions: _.identity,

        showContent: function(key, options) {
            var view = this.getView(key, options);
            this.view.layout.setContent(view).renderContent();
            this.tabs.get(key).trigger('toggle:active', true);

        },

        getView: function(key, options) {
            var viewObj = this.view,
                view = viewObj[key];
            if (!view) {
                options = this.getContentViewOptions(options);
                view = viewObj[key] = new this.content[key](options);
                this.listenTo(view, {
                    'back': this.close,
                    'panel:stack': this.stackPanel
                });
                this.onContentViewCreate(view, options);
            }
            return view;
        },

        close: function() {
            this.trigger('back');
            this.onClosePanel();
            Backbone.$('.panel-content > div > .menu-actions', this.$el).removeClass('fixed');
        },

        disableSubViews: function() {
            this.view.layout.disable();
        },

        getDefaultHeaderTitle: function() {
            var header = _result(this, 'header');
            return header.title;
        },

        getDefaultHeaderSubtitle: function() {
            var header = _result(this, 'header');
            return header.subtitle;
        },

        ////////////
        // events //
        ////////////
        onContentViewCreate: _.noop,
        onClosePanel: _.noop,
        onOpen: _.noop,
        stackPanel: function(view) {
            this.trigger('panel:stack', view);
        },

        onRedirectedToConversation: function () {
            this.close();
        },

        // onOpen: function() {
        //     this.setMenuActionsWidth();
        // },
        // contructor: function() {
        //   // _extend(this, {
        //   //     onScroll: _.throttle(this.onScroll, 125)
        //   // });
        // }
        // setMenuActionsWidth: function() {
        //     // Get the width of the panel-content and remove margin to set size of menu-actions
        //     var btnActionWidth = this.zone.$content.width() - 30,
        //         menu = this.getMenu();
        //     if (menu) menu.$el.width(btnActionWidth);
        //     return this;
        // },
        // onResize: function(e, width) {
        //     if (this.zone) this.setMenuActionsWidth();
        // },
        //
        // onScroll: function(e) {
        //
        //     var zone = this.zone,
        //         menu = this.getMenu();
        //     if (!menu) return;
        //     var scrollTop = e.currentTarget.scrollTop, // Define the scrollTop value
        //         headerHeight = zone.$header.outerHeight() + zone.$tabs.outerHeight(),
        //         isFixed = scrollTop >= headerHeight - 5;
        //
        //     if (!isFixed) this.setMenuActionsWidth();
        //     menu.$el.toggleClass('fixed', isFixed);
        // },

    });

    return VBasePanel;
});

